import { useMemo } from "react"
import { matchPath, useLocation } from "react-router-dom"

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function useMatch<T>(path: string) {
    const location = useLocation()
    const match = useMemo(() => {
        return matchPath<string>(path, location.pathname)
    }, [path, location.pathname])

    if (!match) {
        return undefined
    }
    return match
}
